import { hmmmToSlot } from '@/config/modeConfig';

/**
 * One zone's manning band as spans on the slot axis: each stats entry runs until the
 * next entry's time (the last to the end of the shift), and neighbouring entries with
 * the same count for this zone merge into one wider cell.
 */
export function zoneBandSpans(
  entries: Array<{ time: string; zones: string }>,
  zoneIdx: number,
  startHour: number,
  numSlots: number,
): Array<{ startSlot: number; endSlot: number; value: string }> {
  const spans: Array<{ startSlot: number; endSlot: number; value: string }> = [];
  entries.forEach(({ time, zones }, i) => {
    let startSlot: number;
    try { startSlot = hmmmToSlot(time, startHour); } catch { return; }
    const nextEntry = entries[i + 1];
    const endSlot = nextEntry ? hmmmToSlot(nextEntry.time, startHour) : numSlots;
    if (endSlot <= startSlot) return;
    const value = zones.split('/')[zoneIdx]?.trim() ?? '–';
    const last = spans[spans.length - 1];
    if (last && last.value === value && last.endSlot === startSlot) last.endSlot = endSlot;
    else spans.push({ startSlot, endSlot, value });
  });
  return spans;
}
